import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { Base, IBase } from "mobx-stores/_models/base";
import {
  IAddPaperGoodsReceiptItem,
  IUpdatePaperGoodsReceiptItem,
  PaperGoodsReceiptItem,
} from "./paper-goods-receipt-item";

export const PaperGoodsReceipt = types.compose(
  Base,
  types.model({
    receiptDate: types.maybeNull(types.string),
    items: types.optional(types.array(PaperGoodsReceiptItem), []),
  })
);
export interface IPaperGoodsReceipt
  extends Instance<typeof PaperGoodsReceipt> {}
export interface IPaperGoodsReceiptProperties
  extends SnapshotIn<typeof PaperGoodsReceipt> {}

export interface IAddPaperGoodsReceipt
  extends Omit<IPaperGoodsReceiptProperties, keyof IBase> {
  items: IAddPaperGoodsReceiptItem[];
}

export interface IUpdatePaperGoodsReceipt
  extends Omit<IPaperGoodsReceiptProperties, "items"> {
  items: IUpdatePaperGoodsReceiptItem[];
}
